import React, {useEffect, useState} from 'react'
import {BASE_URL} from '../utils/commonUrl';
import Layout from '../components/Layout'
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux'
import CompetencyTitleIndicatorForm from "./forms/CompetencyTitleIndicatorForm";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {fetchCompetencyTitleIndicator} from "../redux/features/competencyTitleIndicator.feature";
import {fetchUserRoleIndicator} from "../redux/features/competencyTitleIndicator.feature";
import { textAlign } from '@mui/system';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const CompetencyTitleIndicator = () => {    
    const dispatch = useDispatch();
    const state = useSelector((state => state["competencytitleindicator"]))
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);
    const [activeCompetencyTitleNames, setactiveCompetencyTitleNames] = useState([]);// DropDown
    const [activeUserRoleNames, setactiveUserRoleNames] = useState([]);// DropDown
    const [isLoading, setIsLoading] = useState(false);
	
    const [competencyTitleIndicatorItem, setCompetencyTitleIndicatorItem] = useState({
					competencyTitleIndicatorID: 0,
                    competencyID:0,  
                    userRoleID:0,                  
					 indicatorSequenceNo: "",
					 indicatorTitle: "",
					 indicatorTitleBangla: "",
					 indicatorValue: 0,
					 active: true,
    })

    useEffect(() => {
        dispatch(fetchCompetencyTitleIndicator())
        dispatch(fetchUserRoleIndicator())
        UserRoleActiveNames()
        CompetencyTitleIndicatorActiveNames()
        initFilters1();
    }, [])

    const CompetencyTitleIndicatorActiveNames = async () => {
        try {
            const url = BASE_URL + '/api/competency/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const optionList = [{value: '-1', label: '--Please Select Competency--'}];
                response.data.map(val => optionList.push({value: val.competencyID, label: val.competencyName}))

                setactiveCompetencyTitleNames(optionList)
            }

        } catch (e) {
            console.log(e)
        }

    }

    const UserRoleActiveNames = async () => {
        try {
            const url = BASE_URL + '/api/userRole/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const optionList = [{value: '-1', label: '--Please Select Role--'}];
                response.data.map(val => optionList.push({value: val.userRoleID, label: val.roleName}))

                setactiveUserRoleNames(optionList)
            }

        } catch (e) {
            console.log(e)
        }

    }

    const onSubmit = async data => {
        console.log(data);
        try {
            setIsLoading(true)
            const url = BASE_URL + "/api/competencyTitleIndicator";
            const response = await axios.post(url, data);
            setIsLoading(false)
            if (response.status === 200) {
                dispatch(fetchCompetencyTitleIndicator())
                setCompetencyTitleIndicatorItem({
                    competencyTitleIndicatorID: 0,
                    competencyID:0,
                    userRoleID:0,					 
					 indicatorSequenceNo: "",
					 indicatorTitle: "",
					 indicatorTitleBangla: "",
					 indicatorValue: 0,
					 active: true,
                })
                setModal(!modal)
            }
        } catch (e) {
            console.log(e)
            setIsLoading(false)
        }


    }

    const onHide = () => {
        setModal(!modal)
        setCompetencyTitleIndicatorItem({
                    competencyTitleIndicatorID: 0,
                    competencyID:0,	
                    userRoleID:0,				
					indicatorSequenceNo: "",
					indicatorTitle: "",
					indicatorTitleBangla: "",
					indicatorValue: 0,
					active: true,
        })
    }
	
    const editGridData = data => {
        //console.log(data);
        setCompetencyTitleIndicatorItem({
            competencyTitleIndicatorID: data.competencyTitleIndicatorID,
            competencyID:data.competencyID, 
            userRoleID:data.userRoleID,           
            indicatorSequenceNo: data.indicatorSequenceNo,
            indicatorTitle: data.indicatorTitle,
            indicatorTitleBangla: data.indicatorTitleBangla,
            indicatorValue: data.indicatorValue,
            active: data.active,
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteassestmentTitleIndicatorItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }



    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'indicatorSequenceNo': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            //'competencyTitle.competencyTitleName': {
            //    operator: FilterOperator.AND,
            //    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            //},
            'indicatorTitle': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'indicatorTitleBangla': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end



    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Competency Indicator
                </button>
            </div>
        </div>
    );

    const footer =`In total there are ${state.competencytitleindicators ? state.competencytitleindicators.length : 0} competencyTitleIndicator.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={state.competencytitleindicators}
                   showGridlines
                   dataKey="competencyTitleIndicatorID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['competencyTitle.competencyTitleName', 'indicatorSequenceNo','indicatorTitle','indicatorTitleBangla','active']}
                   header={header} footer={footer} paginator rows={7} first={start}
                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="competencyTitleIndicatorID" header="competencyTitleIndicatorID" hidden={true}/>
            <Column field='indicatorSequenceNo' header="Sequence No"/>
            <Column field="userRoleID" header="Role"/>            
            <Column field="competency.competencyName" header="Competency"/>            
            <Column field='indicatorTitle' header="Title"/>
            <Column field='indicatorTitleBangla' header="IndicatorTitleBangla" hidden={true}/>
            <Column field='indicatorValue' header="IndicatorValue" hidden={true}/>
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem', textAlign:"center"}}/>
        </DataTable>
    )
	
    return (
        <Layout>
            <CompetencyTitleIndicatorForm
                isLoading={isLoading}                
                setactiveCompetencyTitleNames={activeCompetencyTitleNames}
                setactiveUserRoleNames={activeUserRoleNames}
                competencyTitleIndicatorID={competencyTitleIndicatorItem.competencyTitleIndicatorID} 
                competencyID={competencyTitleIndicatorItem.competencyID}  
                userRoleID={competencyTitleIndicatorItem.userRoleID}  
                indicatorSequenceNo={competencyTitleIndicatorItem.indicatorSequenceNo}
                indicatorTitle={competencyTitleIndicatorItem.indicatorTitle}
                indicatorTitleBangla={competencyTitleIndicatorItem.indicatorTitleBangla}
                indicatorValue={competencyTitleIndicatorItem.indicatorValue}
                active={competencyTitleIndicatorItem.active}
                modal={modal}
                onSubmit={onSubmit}
                onHide={onHide}/>
            {Table}
        </Layout>
    )
}

export default CompetencyTitleIndicator